export default class GuidUtil {
    /**
     *
     * @param len 时间戳后面随机字符串的长度
     * @returns
     */
    static nextId(len) {
        len = len || 5;
        let timestamp = new Date().getTime().toString();
        /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
        let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
        let maxPos = $chars.length;
        let randomStr = '';
        for (let i = 0; i < len; i++) {
            randomStr += $chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return timestamp + randomStr;
    }
}
//# sourceMappingURL=guidUtil.js.map